import { List, Space, Typography } from 'antd';
import { Button, Card, Status } from '@insight-health-ai/roseate/components';

import { useMagicFlowVersionsContext } from '../MagicFlowVersionsContext';

export type { VersionedRecord } from '../MagicFlowVersionsContext';

export const MagicFlowVersionsCard = () => {
  const {
    versions,
    activatingId,
    isActivatingPending,
    onActivate,
    onSelect,
    currentId,
    emptyText = 'No version history yet.',
  } = useMagicFlowVersionsContext();

  return (
    <Card title="Versions" padding={{ body: 'sm', header: 'sm' }}>
      {versions.length === 0 ? (
        <Typography.Text type="secondary">{emptyText}</Typography.Text>
      ) : (
        <List
          size="small"
          dataSource={versions}
          renderItem={(version) => {
            const isCurrent = Boolean(currentId) && version.id === currentId;
            const label = (
              <Space direction="vertical" size={0}>
                <Space size={4}>
                  <Typography.Text className="font-mono">
                    v{version.version ?? '?'}
                  </Typography.Text>
                  {isCurrent ? (
                    <Status appearance="info" label="viewing" size="xs" />
                  ) : null}
                </Space>
                <Typography.Text type="secondary" className="text-xs">
                  {version.updated_at
                    ? new Date(version.updated_at).toLocaleString()
                    : '-'}
                </Typography.Text>
              </Space>
            );

            return (
              <List.Item
                className={isCurrent ? 'bg-blue-50' : undefined}
                actions={[
                  version.is_active ? (
                    <Status
                      key="active"
                      appearance="success"
                      label="active"
                      size="xs"
                    />
                  ) : (
                    <Button
                      key="activate"
                      variant="outlined"
                      appearance="secondary"
                      size="sm"
                      loading={
                        isActivatingPending && activatingId === version.id
                      }
                      onClick={() => onActivate(version.id)}
                    >
                      Activate
                    </Button>
                  ),
                ]}
              >
                {onSelect && !isCurrent ? (
                  <Button
                    variant="text"
                    appearance="primary"
                    size="sm"
                    className="!p-0 h-auto text-left"
                    onClick={() => onSelect(version.id)}
                  >
                    {label}
                  </Button>
                ) : (
                  label
                )}
              </List.Item>
            );
          }}
        />
      )}
    </Card>
  );
};
